import { css } from "@styled-system/css";
import { Flex } from "@styled-system/jsx";

export default function SaveBadge({ save = "50%" }) {
  return (
    <Flex
      bg="warning"
      className={css({
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: "0%",
        right: "0%",
        width: ["5rem", "7.75rem", null, "9.75rem"],
        height: ["5rem", "7.75rem", null, "9.75rem"],
        borderRadius: "100%",
        zIndex: 2,
        transform: ["translate(15%, -15%)", "translate(30%, -30%)"]
      })}
    >
      <h2 className={css({ color: "white", fontSize: ["24px", "38px", null, "48px"] })}>{`-${save}`}</h2>
    </Flex>
  );
}
